import { FindPlan, Query } from '@wolfdanepug/common-react'
import { useOutletContext } from 'react-router'
import PlanCard from '../plan/PlanCard'

export default function PetPlanOverview() {
	const { profile }: any = useOutletContext()

	return (
		<Query
			doc={FindPlan}
			cache="cache-first"
			variables={{ profile: profile?.id }}
			getData={(data: any) => ({ plan: data })}
			component={PlanCard}
		/>
	)
}
